import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameRepresentative extends cDisplay {

  private curScreen: cInlineDisplay
  private curSelected: any;
  private qData:any

  private curScore: any 

  init(){

    var cS:cScene = this.scene as cScene;

    super.init()
    console.log('INIT representative 1');

    this.curSelected = null;
    this.curScore = 4;

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'update_score':
          console.log('UPDATE SCOER',b.payload)
          this.curScore += b.payload.score
          if (this.curScore < 0) this.curScore = 0
          break
        case 'show_score':
          cS.triggerSceneEvent('show_score',{score:this.curScore, type:'representative'})
      }
    })

  }

  buildScene(){    
    super.buildScene();
  }
}
